import LocomotiveScroll from 'locomotive-scroll';
//import "locomotive-scroll/locomotive-scroll.css";

const Infografico = () => {
    const locomotiveScroll = new LocomotiveScroll();
    const isMobile = window.matchMedia("(max-width: 1024px)").matches;

    if (!isMobile) {
        window.addEventListener('progressInfografico', (e) => {
            const { target, progress } = e.detail;
            const index = Number(target.dataset.index);
            const baseCalc = 100;

            const el = document.querySelector(`[data-index="${index}"]`);
            if (!el) return;

            el.querySelectorAll('.texto, .layer-icon').forEach(el => {
                el.style.opacity = progress;
            });

            if (index > 1) {
                el.style.top = `${progress * (baseCalc * (index - 1))}px`;
            }
        });
    }
};

export default Infografico;

Infografico();
